import useMartyContext from 'hooks/useMartyContext';
import primeLogoSrc from 'images/amazon-prime.svg';
import { useFeaturePdpEnhancements } from 'hooks/unleash/useFeaturePdpEnhancements';

import css from 'styles/components/productdetail/twoDayShippingPerk.scss';

export default function TwoDayShippingPerk() {
  const { testId } = useMartyContext();

  const { isTreatmentPricingEnabled } = useFeaturePdpEnhancements();

  if (isTreatmentPricingEnabled) {
    return (
      <div className="flex items-start justify-start" data-test-id={testId('shippingPerkBox')}>
        <div className="w-full">
          <strong>FREE</strong> upgraded shipping & returns with
          <img className="h5 ml-1 w-8" src="https://m.media-amazon.com/images/G/01/zappos/ui/prime-icon.svg" alt="Amazon Prime" />
        </div>
      </div>
    );
  }

  return (
    <div className={css.wrapper} data-test-id={testId('shippingPerkBox')}>
      <div className={css.message}>
        <strong>FREE</strong> upgraded shipping & returns with
      </div>
      <img className={css.image} src={primeLogoSrc} alt="Amazon Prime" />
    </div>
  );
}
